import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {AddCircle, VisibilityOff, Visibility, Help} from '@material-ui/icons';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Group from '../../../Domain/Models/Group';
import { groupRepository } from '../../../Domain/Repositories/GroupRepository';
import DecisionModal from "../../UiComponents/DecisionModal";
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import PredefinedRouteContent from "../PredefinedRoutes/PredefinedRouteContent";
import PredefinedRouteModal from "../PredefinedRoutes/PredefinedRouteModal";
import PredefinedRoute from "../../../Domain/Models/PredefinedRoute";
import {cubeRepository} from "../../../Domain/Repositories/CubeRepository";
import PlayerPairContent from "../PlayerPairs/PlayerPairContent";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import {CompletedCubeService} from "../../../Domain/Services/CompletedCubeService";
import Cube from "../../../Domain/Models/Cube";
import {CubeStateService} from "../../../Domain/Services/CubeStateService";
import {CubeState} from "../../../Domain/Models/CubeState";
import {cubeHelpRepository} from "../../../Domain/Repositories/CubeHelpRepository";
import CubeHelp from "../../../Domain/Models/CubeHelp";
import CubeHelpElement from "./CubeHelpElement";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  },
}));


interface CubeContentParams
{
  cubeId: string;
}

export default function CubeContent()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);
  const {cubeId} = useParams<CubeContentParams>();

  const [cube, setCube] = useState<Cube>();
  const [cubeState, setCubeState] = useState<CubeState>();
  const [loading, setLoading] = useState(false);

  const forceReload = () =>
  {
    setLoading(true);
    cubeRepository.load()
      .then(() =>
      {
        const foundCube = cubeRepository.getById(cubeId);
        setCube(foundCube);

        if (foundCube === undefined)
        {
          return Promise.reject("Cube not found");
        }
      })
      .then(() => CubeStateService.getState(cubeId))
      .then((state) =>
      {
        setCubeState(state);
        setLoading(false);
      })
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      });
  }

  useEffect(() =>
  {
    forceReload();

  }, []);

  return (
    <>
      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              {cube?.name}
            </Typography>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Active Group</TableCell>
                  <TableCell>Queue Line Group</TableCell>
                  <TableCell>Maintenance Mode</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                  <TableRow key={cube?.id} hover>
                    <TableCell>
                      {cubeState?.activeGroup?.playerPairs.map(x => x.name).join(' vs. ')}
                    </TableCell>
                    <TableCell>
                      {cubeState?.groupInQueueLine?.playerPairs.map(x => x.name).join(' vs. ')}
                    </TableCell>
                    <TableCell>
                      {cube?.maintenanceMode ? "Enabled" : "Disabled"}
                    </TableCell>
                  </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>

        {cube?.difficultyTypes.map((x) => (
          <CubeHelpElement cubeId={cubeId} difficulty={x} errorCardController={errorCardControllerRef} />
        ))}
      </Loading>
    </>
  );
}